import { render, staticRenderFns } from "./TotalUrls.vue?vue&type=template&id=3e19653b"
import script from "./TotalUrls.vue?vue&type=script&lang=js"
export * from "./TotalUrls.vue?vue&type=script&lang=js"
import style0 from "./TotalUrls.vue?vue&type=style&index=0&id=3e19653b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports